import { Capacitor } from '@capacitor/core';
import { EMPTY } from 'rxjs';
import { createCustomerDisplayServerPlugin } from '@core/capacitor-plugins/capacitor-plugins.class';

const createUnsupportedPlatformStub = () => {
  let warned = false;
  const warn = () => {
    if (warned) return;
    warned = true;
    console.warn(`"CustomerDisplay" plugin is not implemented on ${Capacitor.getPlatform()}`);
  };
  return {
    enable: () => { warn(); return Promise.resolve(); },
    disable: () => { warn(); return Promise.resolve(); },
    send: () => { warn(); return Promise.resolve({} as any); },
    receive: () => { warn(); return EMPTY; },
    availableDisplays: () => { warn(); return EMPTY; },
    onDisabled: () => { warn(); return EMPTY; },
  } as any;
};

export const CustomerDisplayPlugin =
  Capacitor.getPlatform() === 'android' ? createCustomerDisplayServerPlugin() : createUnsupportedPlatformStub();
